import SideWrapper from "./SideWrapper"

export default SideWrapper
